import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './pages/Static-Pages/PrivacyPolicy';
import CancellationPolicy from './pages/Static-Pages/CancellationPolicy';
import RefundPolicy from './pages/Static-Pages/RefundPolicy';

const Home = lazy(() => import('./pages/home'));
const Costumes = lazy(() => import('./pages/costumes'));
const PackagePage = lazy(() => import('./pages/package/PackagePage'));
const SetsPage = lazy(() => import('./pages/sets/setPage'));

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='sets' element={<SetsPage />} />
          <Route path='packages' element={<PackagePage />} />
          <Route path='costumes' element={<Costumes />} />
          <Route path='privacy-policy' element={<PrivacyPolicy />} />
          <Route path='cancellation-policy' element={<CancellationPolicy />} />
          <Route path='refund-policy' element={<RefundPolicy />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
